require('./cardModifyLimitModalSection.scss');
const PropTypes = require('prop-types');
//@vendor
const React = require('react');
//@utilites
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getFormattedString } = require('utilities/currencyHelper');
//@commons
const { RadioButton } = require('commonsComponents/radioButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const OKModal = require('components/commons/OKModal/OKModal');
//@constants
const {
    CARD_MODIFY_LIMIT_INCREASE_PENDING,
    CARD_MODIFY_LIMIT_INCREASE_APPROVED
} = require('constants/index');

class CardModifyLimitModalSection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            radioButtonSelectedValue: CARD_MODIFY_LIMIT_INCREASE_APPROVED
        };

        this.handleClickContinueButton = this.handleClickContinueButton.bind(this);
        this.handleClickCancelButton = this.handleClickCancelButton.bind(this);
        this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
    }

    buildRadioButtonSection() {
        const formattedSuggestedAmount = getFormattedString(this.props.suggestedAmount);
        const formattedPendingAmount = getFormattedString(this.props.pendingAmount);
        const radioButtonApprovedText = formatText('cardModifyLimitModalSection-aprovedMessage', [formattedSuggestedAmount]);
        const radioButtonPendingText = formatText('cardModifyLimitModalSection-pendingMessage', [formattedPendingAmount]);

        return (
            <div className="card-modify-limit-modal-section__radio-buttons-section">
                <RadioButtonGroup
                    selectedValue={this.state.radioButtonSelectedValue}
                    onChange={this.handleRadioButtonChange}
                    idPrefix="cardModifyLimitModalSection"
                    name="cardModifyLimitModalSection"
                >
                    <RadioButton
                        label={radioButtonApprovedText}
                        value={CARD_MODIFY_LIMIT_INCREASE_APPROVED}
                    />
                    <RadioButton
                        label={radioButtonPendingText}
                        value={CARD_MODIFY_LIMIT_INCREASE_PENDING}
                    />
                </RadioButtonGroup>
            </div>
        );
    }

    handleClickCancelButton() {
        this.props.handleCancel();
    }

    //event handlers
    handleClickContinueButton() {
        this.props.handleContinue(this.state.radioButtonSelectedValue);
    }

    handleRadioButtonChange(option) {
        this.setState({
            radioButtonSelectedValue: option
        });
    }

    render() {
        const { isOpen } = this.props;
        const radioButtonSection = this.buildRadioButtonSection();
        const content = (
            <div className="card-modify-limit-modal-section__body">
                <FormattedText
                    value="cardModifyLimitModalSection-message"
                    className="card-modify-limit-modal-section__message"
                />
                {radioButtonSection}
            </div>
        );

        return (
            <OKModal
                content={content}
                footerType="navigation"
                isOpen={isOpen}
                onCloseCallback={this.handleClickCancelButton}
                onPrimaryButtonClick={this.handleClickContinueButton}
                onSecondaryButtonClick={this.handleClickCancelButton}
                primaryButtonText="common-continue"
                secondaryButtonText="common-cancel"
                title="cardModifyLimitModalSection-title"
            />
        );
    }
}

CardModifyLimitModalSection.propTypes = {
    suggestedAmount: PropTypes.object,
    pendingAmount: PropTypes.object,
    isOpen: PropTypes.bool,
    handleCancel: PropTypes.func,
    handleContinue: PropTypes.func
};

CardModifyLimitModalSection.defaultProps = {
    isOpen: false,
    handleCancel: function () { },
    handleContinue: function () { }
};

module.exports = CardModifyLimitModalSection;